<script setup>
import { onMounted, onUnmounted, provide, ref } from 'vue'
import { key_Escape, onCodeDown } from 'on-hotkey'
import { UAParser } from 'ua-parser-js'

const props = defineProps({
  wrapperClass: {
    type: String,
    default: 'max-w-md mx-auto w-full h-full flex'
  },
  onDestroy: {
    type: Function,
    default: () => {}
  },
  allowCloseByClickOutside: {
    type: Boolean,
    default: true
  }
})

const isOpen = ref(false)

onMounted(() => {
  isOpen.value = true

  document.body.style.overflow = 'hidden'
})

function close (type) {
  if (type === 'overlay') {
    if (!props.allowCloseByClickOutside) {
      return
    }
  }

  isOpen.value = false

  setTimeout(() => {
    document.body.style.overflow = ''
    props.onDestroy()
  }, 200)
}

provide('close', close)

const unsubscribeEscapeKey = onCodeDown(key_Escape, () => {
  close()
})

onUnmounted(() => {
  unsubscribeEscapeKey()
})

defineExpose({
  isOpen
})

const { device, os } = UAParser()
const isMobile = device.is('mobile') || device.is('tablet')
const isIOS = os.name === 'iOS'
</script>

<template>
  <div
    role="dialog"
    class="fixed inset-0 z-40 overflow-y-auto h-full w-full"
    aria-modal="true"
    @click="close('overlay')">
    <!-- Overlay -->
    <transition name="fade">
      <div
        v-show="isOpen"
        class="fixed inset-0 bg-black/70"/>
    </transition>

    <div
      v-if="isMobile && isIOS"
      class="h-[5px] bg-white fixed left-0 bottom-0 right-0 z-10"/>

    <!-- Panel -->
    <transition name="fade-appear">
      <div
        v-show="isOpen"
        :class="[isOpen ? 'visible' : 'invisible']"
        class="relative w-full h-full flex items-center justify-center">
        <div
          :class="[wrapperClass]"
          class="overflow-auto max-h-screen relative overflow-x-hidden scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 scrollbar-thumb-rounded-full"
          @click.stop>
          <slot/>
        </div>
      </div>
    </transition>
  </div>
</template>
